import * as types from '@/store/mutations'
import api from '@/services/products'

const getters = {
  products: (state)=> state.products,
  categories: (state) => state.categories,
  
  getCategory: (state) => (categoryId) => {
    const item = state.categories.find((obj) => {
      return obj.id === categoryId
    })
    if (item) {
      return item
    }
    return false
  },
  
  getStockItem: (state) => ( artno ) => {
    const item = state.stock.find((obj) => {
      return parseInt(obj.sku) == parseInt(artno)
    })
    if (item) {
      return item
    }
    return false
  },
  getLowStockList: (state) => (  ) => {
    let arr = []
    state.stock.filter((stockObj)=>{ return stockObj.lowStock === 1 }).map((item)=>{
      arr.push(item.sku)
    })
    return arr

  },
  getCategoryProducts: (state) => (categoryId) => {
    const item = state.categories.find((obj) => {
      return obj.id === categoryId
    })
    if (item) {
      return Object.keys(item.products)
    }
    return []
  },
  
  getProductCollection: (state) => (artnos) =>{
    return state.products.filter((prod)=>{ return artnos.includes(prod.SKU) })
  },

  getActiveProductCollection: (state) => (artnos) =>{
    return state.products.filter((prod)=>{
      if (prod.lifecycle.status == 'main') {
        return artnos.includes(prod.SKU)
      }
    })
  },
  
  getProduct: (state) => (sku) => {
    let prods = state.products.filter((prod)=>{ return parseInt(sku) === parseInt(prod.SKU)});
    if(prods.length > 0){
      return prods[0]
    }else{
      return null
    }
  }
  
  
}

const actions = {
    /*
    * Fetches all products, to be called early in the lifecycle to ensure caching works correctly
    *
    * configuration payload:
    *    params:
    *     culture:'no_NB',
    *     currency:'NOK',
    *     artnos:['46200'],
    *
    * */

    // eslint-disable-next-line no-unused-vars
    loadAllProducts({ commit, state }, payload ) {
      return new Promise((resolve, reject) => {
        let usingCache = false
        const existingCache = JSON.parse(window.localStorage.getItem('productCache'))
        const existingCacheLifetime = JSON.parse(
          window.localStorage.getItem('productCacheLifetime')
        )
        if (existingCache && existingCacheLifetime) {
          if (existingCache.length > 0 && existingCacheLifetime > Date.now()) {
            commit(types.SET_ALL_PRODUCTS, existingCache)
            resolve(1)
            usingCache = true
          }
        }
        
        // usingCache = false
        
        if (usingCache === false) {
          api.productList().then((res)=>{
            const products = []
            res.forEach((prod)=>{
              products.push(prod)
            })
            commit(types.SET_ALL_PRODUCTS, products)
            window.localStorage.setItem(
              'productCache',
              JSON.stringify(products)
            )
            const addedTime =  new Date();
            const newLifetime = addedTime.setHours(addedTime.getHours() + 4)
            window.localStorage.setItem(
              'productCacheLifetime',
              JSON.stringify(newLifetime)
            )
            resolve(1)
          }).catch((ex)=>{
            reject(ex)
          })
        }
      })
    },
  /*
   * Fetches all products, to be called early in the lifecycle to ensure caching works correctly
   *
   * configuration payload:
   *    params:
   *     culture:'no_NB',
   *
   * */
  
  reloadCategoriesAndProducts({ commit }){
    
    return new Promise((resolve, reject) => {
      window.localStorage.removeItem('categoryCache')
      window.localStorage.removeItem('categoryCacheLifetime')
      api.categoryList().then((res)=>{
        const categories = []
        res.list.map((prod)=>{
          categories.push(prod)
        })
        commit(types.SET_ALL_CATEGORIES, categories)
        window.localStorage.setItem(
          'categoryCache',
          JSON.stringify(categories)
        )
        const addedTime =  new Date();
        const newLifetime = addedTime.setHours(addedTime.getHours() + 4)
        window.localStorage.setItem(
          'categoryCacheLifetime',
          JSON.stringify(newLifetime)
        )
        api.productList().then((res)=>{
          const products = []
          res.forEach((prod)=>{
            products.push(prod)
          })
          commit(types.SET_ALL_PRODUCTS, products)
          window.localStorage.setItem(
            'productCache',
            JSON.stringify(products)
          )
          const addedTime =  new Date();
          const newLifetime = addedTime.setHours(addedTime.getHours() + 4)
          window.localStorage.setItem(
            'productCacheLifetime',
            JSON.stringify(newLifetime)
          )
          resolve(1)
        }).catch((ex)=>{
          reject(ex)
        })
      }).catch((ex)=>{
        reject(ex)
      })
    })
  },
  
  loadProductsOfType(context, payload ) {
    return new Promise((resolve, reject) => {
      return api.productsOfType(payload.type).then((res)=>{
        resolve(res)
      }).catch((r)=>{
        reject(r)
      })
    })
  },
  
  loadProductStock(store) {
    return new Promise((resolve, reject) => {

      let usingCache = false

      const existingCache = JSON.parse(window.localStorage.getItem('stockCache'))

      const existingCacheLifetime = JSON.parse(
          window.localStorage.getItem('stockCacheLifetime')
      )
      if (existingCache && existingCacheLifetime) {
        if (existingCache && existingCacheLifetime > Date.now()) {
          store.commit(types.SET_PRODUCT_STOCK,existingCache)
          usingCache = true
          resolve(1)
        }
      }

      if(usingCache === false){
        return api.productStock().then((res)=>{
          const stock = []
          res.map((el)=>{
            stock.push(el)
          })
          store.commit(types.SET_PRODUCT_STOCK,stock)
          window.localStorage.setItem(
              'stockCache',
              JSON.stringify(stock)
          )
          const addedTime =  new Date();
          const newLifetime = addedTime.setMinutes(addedTime.getMinutes() + 1)
          window.localStorage.setItem(
              'stockCacheLifetime',
              JSON.stringify(newLifetime)
          )



          resolve(res)
        }).catch((r)=>{
          reject(r)
        })
      }




    })
  },
  
  // eslint-disable-next-line no-unused-vars
  loadAllCategories({ commit, state }, payload ) {
    return new Promise((resolve, reject) => {
      let usingCache = false
      const existingCache = JSON.parse(window.localStorage.getItem('categoryCache'))
      const existingCacheLifetime = JSON.parse(
        window.localStorage.getItem('categoryCacheLifetime')
      )
      if (existingCache && existingCacheLifetime) {
        if (existingCache.length > 0 && existingCacheLifetime > Date.now()) {
          commit(types.SET_ALL_CATEGORIES, existingCache)
          resolve(1)
          usingCache = true
        }
      }
      if (usingCache === false) {
        api.categoryList().then((res)=>{
          const categories = []
          res.list.map((prod)=>{
            categories.push(prod)
          })
          commit(types.SET_ALL_CATEGORIES, categories)
          window.localStorage.setItem(
            'categoryCache',
            JSON.stringify(categories)
          )
          const addedTime =  new Date();
          const newLifetime = addedTime.setHours(addedTime.getHours() + 4)
          window.localStorage.setItem(
            'categoryCacheLifetime',
            JSON.stringify(newLifetime)
          )
          resolve(1)
        }).catch((ex)=>{
          reject(ex)
        })
      }
    })
  }
}

const mutations = {
  [types.SET_ALL_CATEGORIES](state, categories) {
    state.categories = categories
  },
  [types.SET_ALL_PRODUCTS](state, products) {
    state.products = products
  },
  [types.SET_PRODUCT_STOCK](state, stock) {
    state.stock = stock
  }
}

const state = {
  products: [],
  categories: [],
  stock:[]
}

export default {
  state,
  getters,
  actions,
  mutations
}
